import Vuetify from 'vuetify'
import Vue from 'vue'
import Snackbar from '@/components/Snackbar.vue'

Vue.use(Vuetify)
const v = new Vue({
  render(createElement) {
    return createElement(Snackbar)
  },
  vuetify: new Vuetify(),
})

v.$mount()

document.body.appendChild(v.$el)
const snackbar = v.$children[0]
function info(msg) {
  snackbar.info(msg)
}

function error(msg) {
  snackbar.error(msg)
}

function warning(msg) {
  snackbar.warning(msg)
}

function success(msg) {
  snackbar.success(msg)
}
function download(msg) {
  snackbar.download(msg)
}

export default {
  info,
  success,
  warning,
  error,
  download,
}
